import { render, staticRenderFns } from "./ModalEmpresa.vue?vue&type=template&id=0308bbf1&scoped=true"
import script from "./ModalEmpresa.vue?vue&type=script&lang=js"
export * from "./ModalEmpresa.vue?vue&type=script&lang=js"
import style0 from "./ModalEmpresa.vue?vue&type=style&index=0&id=0308bbf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0308bbf1",
  null
  
)

export default component.exports